import icons from 'url:../../img/icons.svg';
import previewView from './previewView.js';
import view from './view.js';

class resultsView extends view {
  _parentEl = document.querySelector('.results');
  _errorMessage = `No recipes found for your query ! Please try again :)`;
  _message = '';

  _generateMarkup() {
    return this._data.map(res => previewView.render(res, false)).join('');
  }
}

export default new resultsView();
